/** Import dependencies */
import './components/cookieConsent'
import UIkitIcons from 'uikit/dist/js/uikit-icons'

/** UIkit Icons Plugin */
UIkit.use(UIkitIcons)

import { router } from 'js-dom-router'

/** Routes */
import site from './views/site'
import home from './views/home'
import blog from './views/blog';

router
.on('site', site)
.on('home', home)
.on('post-type-archive-blog', blog)
.ready()



// WEBPACK FOOTER //
// ./resources/js/app.js